<script setup>
import {computed, onMounted, ref} from 'vue'
import api from '@/services/api'
import {usePageSectionsStore} from '@/stores/pageSections'

const props = defineProps({
    sectionId: Number
})

const pageSectionsStore = usePageSectionsStore()

const section = computed(() => pageSectionsStore.items?.find(o => o.id === props.sectionId))

const pageSectionTemplates = ref([])

onMounted(async () => {
    try {
        const response = await api.get('api/component/templates_templates', {
            params: {type: 'section', sort: 'title'}
        })
        pageSectionTemplates.value = response?.data?.items || []
    } catch (error) {
        console.error('Failed to load section templates:', error)
        pageSectionTemplates.value = []
    }
})

const saveSectionTemplateId = async (e) => {
    const sectionTemplateId = parseInt(e.target.value)

    await api.post(`api/page-section/${props.sectionId}`, {sectionTemplateId})

    await pageSectionsStore.init(true)
}
</script>

<template>
    <div>
        <label class="d-block mb-1 small">Template</label>
        <select @change="saveSectionTemplateId" class="form-select form-select-sm w-auto">
            <option value="" selected disabled>Select&hellip;</option>
            <option v-for="o in pageSectionTemplates" :key="o.id" :value="o.id"
                    :selected="o.id === section?.sectionTemplateId">
                {{ o.title }}
            </option>
        </select>
    </div>
</template>